export default __webpack_public_path__ + "static/media/custom-web-dev.png.webp";